<div class="container-fluid">
    <div class="d-flex flex-row justify-content-start align-items-center mt-3">
        <div class="d-inline-flex">
            <div class="icon-page">
                <span class="material-icons">
                    trending_up
                </span>
            </div>
            <h4 class="title-page">
                <span>
                    Indicadores de: 
                </span>
                <span>
                    {{employee.name + " " + employee.lastName}}
                </span>
            </h4>
        </div>
    </div>
    <div class="d-flex flex-row justify-content-start align-items-center mt-3">
        <button type="button" class="btn btn-secondary" (click)="goBack()">
            <span class="material-icons">
                arrow_back
            </span>
            <span>Volver</span>
        </button>
    </div>
    <div class="row mt-3" *ngIf="employee.indicators">
        <app-indicator-table-show [indicatorsIds]="employee.indicators"></app-indicator-table-show>
    </div>
</div>